if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    openCustomCartDrawer() {
      const cartDrawer = document.querySelector('.cart-content');
      const overlay = document.querySelector('.overlay');
      if (!cartDrawer) return;

      document.body.classList.add('stick');
      cartDrawer.classList.add('active');
      if (overlay) overlay.classList.add('overlay_active');
    }

    refreshCustomCartDrawer() {
      if (!window.jQuery) return;
      window.jQuery('#cart-icon-bubble .text-block').load(' #cart-icon-bubble .text-block > *');
      window.jQuery('#cart_reload').load(' #cart_reload .cart_content > *');
    }

    hideCartNotificationPopup() {
      if (!this.cartNotification) return;
      this.cartNotification.classList.remove('active', 'animate');
      const popup = this.cartNotification.querySelector('#cart-notification');
      if (popup) popup.classList.remove('active');
      const overlay = this.cartNotification.querySelector('.cart-overlay');
      if (overlay) overlay.classList.remove('active');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      if (this.cartNotification && this.cartNotification.setActiveElement) {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cartNotification && this.cartNotification.getSectionsToRender) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                this.refreshCustomCartDrawer();
                this.openCustomCartDrawer();
                this.hideCartNotificationPopup();
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.refreshCustomCartDrawer();
            this.openCustomCartDrawer();
            this.hideCartNotificationPopup();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
